import { render, staticRenderFns } from "./Job_Premedia_PremediaGroup_Item.vue?vue&type=template&id=72c079fa&"
import script from "./Job_Premedia_PremediaGroup_Item.vue?vue&type=script&lang=js&"
export * from "./Job_Premedia_PremediaGroup_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports